import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  showBackButton?: boolean;
  actions?: ReactNode;
}

export const PageHeader = ({ title, subtitle, showBackButton, actions }: PageHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className="mb-6 flex items-center justify-between">
      <div className="flex items-center gap-4">
        {showBackButton && (
          <button
            onClick={() => navigate(-1)}
            className="rounded-lg p-2 text-gray-600 transition-colors hover:bg-gray-100 hover:text-gold"
          >
            <ArrowLeftIcon className="h-5 w-5" />
          </button>
        )}
        <div>
          <h1 className="text-xxl font-bold text-gray-800">{title}</h1>
          {subtitle && <p className="mt-1 text-s text-gray-600">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
};
